import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { thunks } from "@/lib/redux/thunks"
import { HotelLocation } from "@/lib/redux/features/hotel/type"
import { Input, InputProps } from "antd"
import { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react"
import { removeVietnameseChars } from "@/utils/string/removeVietnameseChars"
import { getSearchTypeLocationByValue } from "@/utils/hotel/getSearchTypeLocationByValue"

type InputSearchProps = InputProps & {
  onSearch?: (searchValue?: string) => void,
  cardSize?: 'small' | 'default',
  location?: HotelLocation,
  value?: string,
}

export type InputSearchRef = {
  setSearchValue: (value: any) => void,
  getSearchValue: () => any,
}

const InputSearch = forwardRef<InputSearchRef, InputSearchProps>(({ onSearch, cardSize, location, ...props }, ref) => {
  const [searchValue, setSearchValue] = useState<any>(props?.value || '')
  const refTimeoutSearch = useRef<any>(null)
  const dispatch = useAppDispatch()
  const typeSearch = useAppSelector(state => state.hotel.typeSearch)
  useEffect(() => {
    setSearchValue(props?.value)
  }, [props?.value])

  useImperativeHandle(ref, () => {
    return {
      setSearchValue: (value: any) => {
        setSearchValue(value)
      },
      getSearchValue: () => {
        return searchValue
      }
    }
  }, [searchValue])

  return (
    <Input
      {...props}
      value={searchValue}
      onClear={() => dispatch(hotelActions.selectDestination({}))}
      onFocus={() => {
        if (refTimeoutSearch.current) {
          clearTimeout(refTimeoutSearch.current)
        }
        /* Luôn mở bằng tab Phổ biến; không gọi API tìm kiếm khi focus (tránh list kiểu trái khi đã có địa điểm chọn). Tìm kiếm chỉ chạy trong onChange khi người dùng gõ. */
        dispatch(hotelActions.updateSearchingDate(false))
        dispatch(hotelActions.setPopularDestinations({
          show: typeSearch
        }))
      }}
      onChange={(e) => {
        if (!!e.target.value) {

          if (refTimeoutSearch.current) {
            clearTimeout(refTimeoutSearch.current)
          }
          refTimeoutSearch.current = setTimeout(() => {
            dispatch(thunks.hotels_locations_search({
              params: {
                limit: 50,
                offset: 0,
                searchTerm: removeVietnameseChars(e.target.value || ""),
                searchType: getSearchTypeLocationByValue(e.target.value || "")
              }
            }))
          }, 500)
        }

        if (!e.target.value) {
          if (refTimeoutSearch.current) {
            clearTimeout(refTimeoutSearch.current)
          }
          dispatch(hotelActions.setPopularDestinations({
            show: typeSearch
          }))
        }

        setSearchValue(e.target.value)
        if (onSearch) {
          onSearch(e.target.value)
        }
      }}
    />
  )
})

InputSearch.displayName = 'InputSearch'

export default memo(InputSearch)